<p class="error-wrapper">
  <ng-content />
</p>
